import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Location } from "@angular/common";
import { filter, Subscription } from "rxjs";
import { AuthService } from "../../../core/services/auth.service";
import { environment } from "environments/environment";
import { ROUTESSUPERADMIN } from "app/sidebar/sidebar.component";
import { LoadingIndicatorService } from "app/loading-indicator-service";
import { TranslateService } from "@ngx-translate/core";

var misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
};

@Component({
  moduleId: module.id,
  selector: "navbar-superadmin",
  templateUrl: "navbar-superadmin.component.html",
})
export class NavbarSuperAdminComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;
  private _router: Subscription;
  public open: boolean = false;
  loading: boolean = false;
  idCurrentUser: string = AuthService.getFromStorage("id");
  idTypeUser: string = AuthService.getFromStorage("typeUser");
  userName: string = AuthService.getFromStorage("username");
  @ViewChild("navbar", { static: false }) button;

  constructor(
    location: Location,
    public translate: TranslateService,
    private authService: AuthService,
    private renderer: Renderer2,
    private element: ElementRef,
    private router: Router,
    private loadingIndicatorService: LoadingIndicatorService
  ) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
    // change isLoading status whenever notified
    loadingIndicatorService.onLoadingChanged.subscribe(
      (isLoading) => (this.loading = isLoading)
    );
  }

  ngOnInit() {
    this.listTitles = ROUTESSUPERADMIN.filter((listTitle) => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    const body = document.getElementsByTagName("body")[0];
    this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
    if (body.classList.contains("sidebar-mini")) {
      misc.sidebar_mini_active = true;
    }
    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const $layer = document.getElementsByClassName("close-layer")[0];
        if ($layer) {
          $layer.remove();
        }
      });
  }

  changeLanguage(lang: string) {
    this.authService.saveLocalStorage(environment.storageLanguageNameApi, lang);
    this.translate.use(lang);
    setTimeout(function () {
      window.location.reload();
    }, 500);
  }

  minimizeSidebar() {
    const body = document.getElementsByTagName("body")[0];

    if (misc.sidebar_mini_active === true) {
      body.classList.remove("sidebar-mini");
      misc.sidebar_mini_active = false;
    } else {
      setTimeout(function () {
        body.classList.add("sidebar-mini");

        misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  isMobileMenu() {
    if (window.outerWidth < 991) {
      return false;
    }
    return true;
  }

  sidebarOpen() {
    var toggleButton = this.toggleButton;
    var html = document.getElementsByTagName("html")[0];
    setTimeout(function () {
      toggleButton.classList.add("toggled");
    }, 500);
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );
    if (window.innerWidth < 991) {
      mainPanel.style.position = "fixed";
    }
    html.classList.add("nav-open");
    this.sidebarVisible = true;
  }
  sidebarClose() {
    var html = document.getElementsByTagName("html")[0];
    this.toggleButton.classList.remove("toggled");
    this.sidebarVisible = false;
    html.classList.remove("nav-open");
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );

    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = "";
      }, 500);
    }
  }
  sidebarToggle() {
    var toggleButton = this.toggleButton;
    var body = document.getElementsByTagName("body")[0];
    if (this.sidebarVisible == false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  getTitleAdmin() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    const parts = titlee.split("/");
    const interestingPart = parts[2];

    titlee = interestingPart;

    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }
    for (var item = 0; item < this.listTitles.length; item++) {
      var parent = this.listTitles[item];
      if (parent.path === titlee) {
        return parent.title;
      } else if (parent.children) {
        var children_from_url = titlee.split("/")[2];
        for (var current = 0; current < parent.children.length; current++) {
          if (parent.children[current].path === children_from_url) {
            return parent.children[current].title;
          }
        }
      }
    }
    return parent.title;
    return "Dashboard";
  }

  getPath() {
    return this.location.prepareExternalUrl(this.location.path());
  }

  /* Login */
  logout() {
    const id = Number(AuthService.getFromStorage("id"));
    this.authService.logout(id).subscribe({
      next: (response) => {
        localStorage.removeItem(environment.storageTokenNameApi);
        localStorage.removeItem(environment.storageTypeUserNameApi);
        localStorage.removeItem(environment.storageIdUserNameApi);
        localStorage.removeItem(environment.storageLanguageNameApi);
        localStorage.removeItem(environment.storageUsernameNameApi);
        localStorage.removeItem(environment.storageUserPermissionsNameApi);
        localStorage.removeItem(environment.storageUseExternalRecorderNameApi);
        this.router.navigateByUrl("/public/login");
      },
      error: (err) => {
        localStorage.removeItem(environment.storageTokenNameApi);
        localStorage.removeItem(environment.storageTypeUserNameApi);
        localStorage.removeItem(environment.storageIdUserNameApi);
        localStorage.removeItem(environment.storageLanguageNameApi);
        localStorage.removeItem(environment.storageUsernameNameApi);
        localStorage.removeItem(environment.storageUserPermissionsNameApi);
        localStorage.removeItem(environment.storageUseExternalRecorderNameApi);
        this.router.navigateByUrl("/public/login");
      },
      complete: () => {
        console.info("complete");
      },
    });
  }
}
